<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          :has-continue="!this.isFiscalYearIdDefined"
          has-return
          @onReturn="$router.push('/student/parentInventory')"
          @onContinue="onContinueClick"
        />
      </div>
    </div>
    <div class="mx-2">
      <div v-if="!isFiscalYearIdDefined" class="row">
        <div class="col-4">
          <section-title
            icon="fa fa-plus-circle"
            content="Crear Tabla de Muestra"
            reverse
            bg-icon="green"
          />
        </div>
      </div>
      <div v-if="!isFiscalYearIdDefined" class="row pt-3 ml-1">
        <div class="col-4">
          <ValidationObserver
            ref="formValidator"
            v-slot="{ handleSubmit }"
            novalidate
          >
            <form ref="form" novalidate @submit.prevent="handleSubmit">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                :rules="`${!fiscalYearSelected ? 'required' : ''}`"
              >
                <custom-dropdown
                  v-model="fiscalYearSelected"
                  fieldkey="id"
                  fieldname="name"
                  :options="fiscalYears"
                  label="Seleccione el año fiscal para el cual desea crear la tabla de muestra:"
                  :error="errors[0]"
                  :custom-error-msg.sync="resources['0675']"
                  @input="LoadProjection"
                />
              </ValidationProvider>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div v-if="showTable">
        <div class="row pt-4">
          <div class="col-4">
            <section-title
              icon="fa fa-file-alt"
              :content="
                `Tabla de Cuestionario ${
                  fiscalYearSelected ? fiscalYearSelected.name : ''
                }`
              "
              reverse
            />
          </div>
        </div>
        <div
          v-for="(item, index) in items"
          :key="`CuestionarioItemRow-${index}`"
          class="row pt-3"
        >
          <div class="col-12 pt-0">
            <custom-callout>
              <div class="row">
                <div class="col-3 pt-0">
                  <custom-tupla name="Región:" :text="item.regionName" />
                </div>
                <div class="col-3 pt-0">
                  <custom-tupla
                    name-center
                    text-center
                    name="Estudiantes:"
                    :text="
                      item.totalStudentByRegion
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                  />
                </div>
                <div class="col-3 pt-0">
                  <custom-tupla
                    name-center
                    text-center
                    name="Muestra a Seleccionar:"
                    :text="item.totalSampleToSelect"
                  />
                </div>
                <div class="col-3 pt-0">
                  <custom-tupla
                    name-center
                    text-center
                    name="Cada Cuanto Caso se Selecciona:"
                    :text="item.sampleToSelectRange"
                  />
                </div>
              </div>
            </custom-callout>
          </div>
        </div>
        <div class="row total-container mx-1 mt-4">
          <div class="col-3 pt-3">
            Total:
          </div>
          <div class="col-3 pt-3 text-center">
            {{
              totalOfStudent.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }}
          </div>
          <div class="col-3 pt-3 text-center">
            {{ totalOfShows }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import PageHeader from '@/components/common/page/PageHeader.vue';
import { SectionTitle } from '@/components/pei/shared';
import CustomDropdown from '@/components/common/CustomDropDown';
import CustomCallout from '@/components/common/CustomCallout';
import CustomTupla from '@/components/common/CustomTupla';
import resourcesService from '@/services/resources.js';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('parentInventory');

export default {
  name: 'SampleInventory',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageHeader,
    CustomDropdown,
    SectionTitle,
    CustomCallout,
    CustomTupla,
  },
  mixins: [alert],
  data: () => ({
    page: {
      icon: 'fas fa-user-circle',
      title: 'Inventario de Padres',
      routes: ['Inicio', 'Estudiante', 'Inventario de Padres'],
    },
    fiscalYears: [],
    items: [],
    resources: [],
    fiscalYearSelected: null,
  }),
  async beforeMount() {
    if (!this.isFiscalYearIdDefined) {
      this.FetchFiscalYears();
      this.LoadResources();
    } else {
      this.FetchSampleTable(this.$route.params.fiscalYearId);
    }
  },
  computed: {
    totalOfShows() {
      return this.items.reduce((a, b) => a + (b.totalSampleToSelect || 0), 0);
    },
    totalOfStudent() {
      return this.items.reduce((a, b) => a + (b.totalStudentByRegion || 0), 0);
    },
    isFiscalYearIdDefined() {
      return this.$route.params.fiscalYearId != undefined;
    },
    showTable() {
      return this.items.length > 0;
    },
  },
  methods: {
    ...mapActions(['loadAcademicYears']),
    async LoadProjection() {
      this.items = [];

      if (!(await this.Validate())) {
        return;
      }

      await this.$ApiGet(
        `api/sampleinventory/sampleinventoryprojection/${this.fiscalYearSelected.id}`
      ).then((res) => {
        this.items = res.data;
      });
    },
    async FetchSampleTable(fiscalYearId) {
      await this.$ApiGet(
        `api/sampleinventory/inventorySampleByFiscalYear/${fiscalYearId}`
      ).then((res) => {
        this.items = res.data;

        this.FetchFiscalYear(fiscalYearId);
      });
    },
    async FetchFiscalYear(fiscalYearId) {
      await this.$ApiGet(
        `api/academicyears/getacademicyearbyid/${fiscalYearId}`
      ).then((res) => {
        this.fiscalYearSelected = {
          id: res.data.id,
          name: res.data.description,
        };
      });
    },
    async FetchFiscalYears() {
      await this.$ApiGet(`api/sampleinventory/fiscalyears`).then((res) => {
        this.fiscalYears = res.data;
      });
    },
    async LoadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '0675',
        '0676',
        '0677',
        '0678',
        '0692',
        '0693',
      ]);
    },
    onReturnClick() {},
    async Validate() {
      let fiscalYearExists = await this.$ApiGet(
        `api/sampleinventory/fiscalyearexists/${this.fiscalYearSelected.id}`
      );

      if (fiscalYearExists.data) {
        this.ShowToast('Alerta', this.resources['0678'], 'error');

        return false;
      }

      let childCountExists = await this.$ApiGet(
        `api/sampleinventory/haschildcountcertification/${this.fiscalYearSelected.id}`
      );

      if (!childCountExists.data) {
        this.ShowToast('Alerta', this.resources['0677'], 'error');

        return false;
      }

      return true;
    },
    async onContinueClick() {
      const formValid = await this.$refs.formValidator.validate();
      if (!formValid) {
        this.ShowToast('Alerta', this.resources['0676'], 'error');

        return false;
      }

      if (!(await this.Validate())) {
        return;
      }

      await this.$ApiPost(
        `api/sampleinventory/createsampleinventorydata/${this.fiscalYearSelected.id}`
      ).then((res) => {
        if (res.data) {
          this.ShowToast('', this.resources['0692'], 'success');
          this.loadAcademicYears();
        } else {
          this.ShowToast('Alerta', this.resources['0693'], 'error');
        }
      });
    },
  },
};
</script>

<style scoped>
.total-container {
  background-color: #2db782;
  color: #ffffff;
  border-radius: 5px;
  padding: 0 10px 20px 10px;
  font: Bold 20px/28px Lato;
}
</style>
